module.exports = __webpack_public_path__ + "media/images/christinasage-1d7a288917712c0324af5b00a24bd7d6.jpg";